// 简体中文表格（机器翻译，未经人工审校 — ruling G4）。
// The Simplified Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
import { boxDims, HW } from '../doc.js';
const S = {
  title: "分格收纳盘",
  view: {
    "2d": "编辑格位",
    "3d": "3D 视图",
  },
  gCell: "选中的格位",
  gSize: "分格盘尺寸",
  gWalls: "侧壁",
  gStack: "堆叠",
  selName: (col, row, c) => `第 ${col + 1} 列 · 第 ${row + 1} 格 —— ${c} 毫米`,
  colSize: "列宽",
  cellSize: "格位深度",
  kinds: {
    auto: "自动",
    "1/2": "1/2",
    "1/3": "1/3",
    "2/3": "2/3",
    mm: "设定毫米",
  },
  split: "拆分格位",
  addCol: "加一列",
  del: "删除格位",
  w: "宽度（毫米）",
  d: "深度（毫米）",
  bed: "打印床（毫米）",
  bedOption: (w, d) => `${w} × ${d}`,
  bedWarn: (w, d) => `托盘大于 ${w} × ${d} 毫米的打印床——可能无法一次打印成型`,
  wall: "壁厚",
  fillet: "圆角半径",
  divider: "隔板高度",
  stackable: "可堆叠（上下边缘互锁）",
  clearance: "堆叠间隙",
  stackNote: (h) => `3 个堆叠：高 ${Math.round((3 * (h - 1) + 1) * 10) / 10} 毫米 · 再加一个托盘增高 ${Math.round((h - 1) * 10) / 10} 毫米`,
  size: (w, d, h) => `${w} × ${d} × ${h} 毫米`,
  gBox: "收纳盒",
  boxOn: "加收纳盒和盖子",
  trayCount: "分格盘数量",
  partLabel: "已下载的部件",
  explode: "分解",
  parts: {
    tray: "分格盘",
    box: "收纳盒",
    latch: "卡扣",
    lid: "盖子",
  },
  boxNote: (wo, dd, hb, n) => `收纳盒 ${wo} × ${dd} × ${hb} 毫米 · 可打印 ${n} 个托盘`,
  hwNote: (hinges) => `${HW.screw} 毫米螺母 × ${hinges} · 插销 ${HW.pin} × ${HW.pinLen} 毫米 × 1（或 1.75 毫米耗材）`,
  bedWarnPart: (part, w, d) => `${part} 打印尺寸为 ${w} × ${d} 毫米——大于打印床，可能无法一次打印成型`,
  tallWarn: (part, z) => `${part} 高 ${z} 毫米——超出大多数打印机的打印高度`,
  problem: {
    "auto-squeezed": "自动排格没有剩余空间——请调小您设定的格位尺寸",
    "too-small": "格位太小（至少需要壁厚的两倍）",
    overflow: "您设定的尺寸加起来超出了托盘",
    "fractions-over": "比例加起来超过 1",
    "corner-clipped": "角落的格位被圆角裁掉——请减小圆角",
    "too-shallow": "托盘太浅——请加高或减小壁厚",
    "stack-wall": "侧壁太薄，撑不住互锁边——请加厚侧壁或减小间隙",
    "stack-shallow": "托盘太浅，无法堆叠——请加高",
    "box-narrow": (doc) => `收纳盒太窄装不下铰链——托盘至少需要 ${Math.round(boxDims(doc).minW * 10) / 10} 毫米，或减小圆角`,
  },
  dlstl: "STL",
  copied: "已复制",
  fatal: "无法加载计算器——请尝试刷新页面",
  unitMm: " 毫米",
  pct: (v) => `${v}%`,
  aboutP: "设计整理抽屉、桌面和工具箱的分格收纳盘。尺寸格位自由设定，还能做可堆叠的边沿，免费下载 3MF/STL。",
};
export default S;
